import { render } from "./Footer.vue?vue&type=template&id=2dfeb71c"
const script = {}
script.render = render

export default script